import React from 'react'
import _ from 'lodash'

interface IMapProps {
  frames: any
  childrenSchema: any // not used directly,

  values: any[]
  valuePath: string
}

export class Map extends React.Component<IMapProps> {
  public render() {
    return <>
      { _.map(this.props.values, this.renderValue) }
    </>
  }

  public renderValue = (value: unknown) => {
    const { frames, valuePath } = this.props
    const renderer = frames.getContext('renderer')
    const childrenSchemaPath = [...frames.getContext('uiSchemaPath'), 'childrenSchema']
    const childrenSchema = _.get(frames.getContext('uiContext'), childrenSchemaPath)

    const newState = { [valuePath]: value }
    const newFrames = renderer.createChildFrame(frames, { uiSchema: childrenSchema, uiSchemaPath: childrenSchemaPath }, newState)

    return renderer.createElementFromFrame(newFrames, {})
  }
}
